<script setup>
    import { BuildingOfficeIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <BuildingOfficeIcon />
</template>
